import { loadMessages } from "devextreme/localization";

// DevExtreme tidak punya kamus Bahasa Indonesia. Teks bawaan grid dan dialog ditimpa di kamus "en"
// supaya format angka dan tanggal (locale) tidak ikut berubah di ~500 layar.
loadMessages({
  en: {
    "dxDataGrid-groupPanelEmptyText": "Seret judul kolom ke sini untuk mengelompokkan",
    "dxDataGrid-filterBuilderPopupTitle": "Susun Filter",
    "dxDataGrid-filterPanelCreateFilter": "Buat filter",
    "dxDataGrid-filterPanelClearFilter": "Hapus",
    "dxDataGrid-filterPanelFilterEnabledHint": "Aktifkan filter",
    "dxDataGrid-searchPanelPlaceholder": "Cari…",
    "dxDataGrid-noDataText": "Tidak ada data",
    "dxDataGrid-editingEditRow": "Ubah",
    "dxDataGrid-editingDeleteRow": "Hapus",
    "dxDataGrid-editingAddRow": "Tambah baris",
    "dxDataGrid-editingSaveRowChanges": "Simpan",
    "dxDataGrid-editingCancelRowChanges": "Batal",
    "dxDataGrid-exportTo": "Ekspor",
    "dxDataGrid-exportToExcel": "Ekspor ke Excel",
    "dxDataGrid-exportAll": "Ekspor semua data ke {0}",
    "dxDataGrid-exportSelectedRows": "Ekspor baris terpilih ke {0}",
    "dxDataGrid-columnChooserTitle": "Pilih Kolom",
    "dxDataGrid-columnChooserEmptyText": "Seret kolom ke sini untuk menyembunyikannya",
    "dxDataGrid-headerFilterOK": "OK",
    "dxDataGrid-headerFilterCancel": "Batal",
    "dxDataGrid-headerFilterEmptyValue": "(Kosong)",
    "dxDataGrid-applyFilterText": "Terapkan filter",
    "dxDataGrid-trueText": "ya",
    "dxDataGrid-falseText": "tidak",
    "dxDataGrid-sortingAscendingText": "Urutkan naik",
    "dxDataGrid-sortingDescendingText": "Urutkan turun",
    "dxDataGrid-sortingClearText": "Hapus urutan",
    "dxDataGrid-groupContinuesMessage": "Berlanjut di halaman berikutnya",
    "dxDataGrid-groupContinuedMessage": "Lanjutan dari halaman sebelumnya",
    "dxDataGrid-summarySum": "Jumlah: {0}",
    "dxDataGrid-summaryCount": "Banyak: {0}",
    "dxDataGrid-summaryMin": "Min: {0}",
    "dxDataGrid-summaryMax": "Maks: {0}",
    "dxDataGrid-summaryAvg": "Rata-rata: {0}",
    "dxDataGrid-ariaSearchInGrid": "Cari di tabel",
    "dxDataGrid-filterRowResetOperationText": "Atur ulang",
    "dxDataGrid-filterRowShowAllText": "(Semua)",
    "dxDataGrid-filterRowOperationEquals": "Sama dengan",
    "dxDataGrid-filterRowOperationNotEquals": "Tidak sama dengan",
    "dxDataGrid-filterRowOperationLess": "Kurang dari",
    "dxDataGrid-filterRowOperationLessOrEquals": "Kurang dari atau sama dengan",
    "dxDataGrid-filterRowOperationGreater": "Lebih dari",
    "dxDataGrid-filterRowOperationGreaterOrEquals": "Lebih dari atau sama dengan",
    "dxDataGrid-filterRowOperationStartsWith": "Diawali",
    "dxDataGrid-filterRowOperationContains": "Mengandung",
    "dxDataGrid-filterRowOperationNotContains": "Tidak mengandung",
    "dxDataGrid-filterRowOperationEndsWith": "Diakhiri",
    "dxDataGrid-filterRowOperationBetween": "Di antara",
    "dxPager-infoText": "Halaman {0} dari {1} ({2} baris)",
    "dxPager-pageSize": "Baris per halaman: {0}",
    "dxPager-pageSizesAllText": "Semua",
    "dxList-selectAll": "Pilih semua",
    "dxCollectionWidget-noDataText": "Tidak ada data",
    "dxLookup-searchPlaceholder": "Ketik minimal {0} huruf",
    Yes: "Ya",
    No: "Tidak",
    Cancel: "Batal",
    Close: "Tutup",
    Clear: "Hapus",
    Done: "Selesai",
    Loading: "Memuat…",
    Search: "Cari",
    Select: "Pilih…",
    "validation-required": "Wajib diisi",
  },
});
